import PropTypes from 'prop-types';
import Link from 'next/link';
import Modal from '../../Atoms/Modal';
import { RawHtml } from '../../Utilities';

const TopicModal = ({ isOpen, onClose, topic }) => {
  if (!topic) return null;

  const modalTitle = (
    <div className="text-block-title">{topic.title}</div>
  );

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size="sm"
      title={modalTitle}
    >
      <div className="topic-modal">
        {topic.summary && (
          <RawHtml html={topic.summary} className="text-body" />
        )}
        {topic.url && (
          <div className="topic-modal__footer">
            <Link href={topic.url} className="btn btn-primary btn-sm" onClick={onClose}>
              Learn more →
            </Link>
          </div>
        )}
      </div>
    </Modal>
  );
};

TopicModal.propTypes = {
  isOpen:  PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  topic: PropTypes.shape({
    title:   PropTypes.string.isRequired,
    summary: PropTypes.string,
    url:     PropTypes.string,
  }),
};

TopicModal.defaultProps = {
  topic: null,
};

export default TopicModal;